import React from "react";

/**
 * On-brand loading indicator — a centered spinner with an optional label.
 * Used for API-driven pages (dynamic pages, blog) while content is fetched.
 */
const Loader = ({ label = "Loading..." }) => (
    <div className="maco-loader" role="status" aria-live="polite">
        <span className="spin" aria-hidden="true" />
        {label && <span className="lbl">{label}</span>}
    </div>
);

export default Loader;
